module.exports = __webpack_public_path__ + "static/media/instructivoa4.8297cb66.png";